// import * as Sentry from "@sentry/solid"
// import { tanstackRouterBrowserTracingIntegration } from "@sentry/solid/tanstackrouter"
import { QueryClient } from "@tanstack/solid-query"
import { createRouter as createTanStackRouter } from "@tanstack/solid-router"
import { setupRouterSsrQueryIntegration } from "@tanstack/solid-router-ssr-query"
import { DefaultCatchBoundary } from "~/components/DefaultCatchBoundary"
import { NotFound } from "~/components/NotFound"
import { queryClientOptions } from "~/queryClient"
import { routeTree } from "~/routeTree.gen"

export interface RouterContext {
  queryClient: QueryClient
}

export function getRouter() {
  const queryClient = new QueryClient(queryClientOptions)

  const router = createTanStackRouter({
    routeTree,
    defaultPreload: "intent",
    defaultErrorComponent: DefaultCatchBoundary,
    defaultNotFoundComponent: () => <NotFound />,
    scrollRestoration: true,
    context: {
      queryClient
    }
  })

  setupRouterSsrQueryIntegration({
    router,
    queryClient
  })

  return router
}

declare module "@tanstack/solid-router" {
  interface Register {
    router: ReturnType<typeof getRouter>
  }
}
